import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeModule } from 'projects/storeadmin/src/app/@theme/theme.module';
import { NbCardModule,NbActionsModule,NbIconModule, NbLayoutModule, NbMenuItem, NbMenuModule, NbMenuService, NbSidebarModule, NbSidebarService,NbDatepickerModule, NbSidebarComponent,} from '@nebular/theme';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, Event, RouterEvent, RouterModule, provideRouter } from '@angular/router';
import { Subject, Subscription, SubscriptionLike, filter, map, takeUntil } from 'rxjs';
import { AssistantConfig, MenuAndTitleOptions, UbsComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { routes } from './admin-routes';
import { UserService } from 'src/app/@core/mock/users.service';
import { UserData } from 'projects/storeadmin/src/app/@core/data/users';
import { LayoutService } from 'projects/storeadmin/src/app/@core/utils';
import { NbAuthService, NbTokenService } from '@nebular/auth';
import { NbAccessChecker, NbAclService, NbRoleProvider } from '@nebular/security';
import { NbSimpleRoleProvider } from 'projects/storeadmin/src/app/@core/core.module';
import { PmsModule, PmsRoutingModule, ProductsModule } from '@urbannex/pms';
import { CmsRoutingModule } from '@urbannex/cms';
import { BlogRoutingModule,UbsBlogModule,UbsBlogService } from '@urbannex/blog';
import { AppInitConfigService, ConfigurationService } from '@urbannex/configuration';
import { environment } from '../../environments/environment';
import { ProductStoreRoutingModule } from '../product-store/product-store-routing.module';
import { PartymgrModule } from "@urbannex/partymgr";
import { RecommenderChatModule } from '@urbannex/recommender-chat';

@Component({
  selector: 'pl-admin',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ThemeModule,
    NbActionsModule,
    NbMenuModule,
    NbLayoutModule,
    NbSidebarModule,
    NbDatepickerModule,
    PmsRoutingModule,
    NbCardModule,
    NbIconModule,
    CmsRoutingModule,
    BlogRoutingModule,
    UbsBlogModule,
    ProductStoreRoutingModule,
    PmsModule,
    ProductsModule,
    RecommenderChatModule,
    PartymgrModule
    ],
  template:`
  <nb-layout windowMode>
    <nb-layout-header fixed>
        <ngx-admin-header [headerTitle]="headerTitle"></ngx-admin-header>
      </nb-layout-header>
      <nb-sidebar class="menu-sidebar admin-sidebar" tag="menu-sidebar" responsive>
      <nb-menu [tag]="menuTag" [items]="menu"></nb-menu>
      <nb-menu tag="contextMenu" [items]="contextMenuItems"></nb-menu>
      </nb-sidebar>
      
        <nb-sidebar right tag="right" state="collpased" #sidebarWatch>
          <ng-container *ngIf="validAssistant">
            <ubs-recommender-chat-container [assistantConfig]="assistantConfig"></ubs-recommender-chat-container>
            <!-- <ubs-recommendation-chat [assistantConfig]="assistantConfig"></ubs-recommendation-chat> -->
          </ng-container>
        </nb-sidebar>
      
      
    <nb-layout-column class="component-layout-column">
        <router-outlet (activate)="processComponent($event)"></router-outlet>
    </nb-layout-column>
  </nb-layout>
`,
  providers:[ UserService,NbSidebarService,LayoutService,NbAuthService,NbTokenService,NbAccessChecker,NbAclService,ConfigurationService,UbsBlogService,
    AppInitConfigService,
    {provide: NbRoleProvider, useClass: NbSimpleRoleProvider}
   ],
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit,AfterViewInit,OnDestroy{
  menu:NbMenuItem[];
  headerTitle:string;
  settings:any[];
  settingsLoaded = false;
  menuTag:string;
  menuSubScription:Subscription;
  contextMenuItems:NbMenuItem[];
  assistantConfig:AssistantConfig;
  
  menuAndTitleOptions:MenuAndTitleOptions[];
  validAssistant:boolean = false;
  

  private destroy$ = new Subject<void>();

  menuTitleOps$ = this.viewContainersService.menuAndTitleOptions$.pipe(
    takeUntil(this.destroy$),
    map(menuAndTitleOptions => menuAndTitleOptions));
  contextMenu$ = this.viewContainersService.contextMenu$.pipe(
    takeUntil(this.destroy$),
    map(contextMenuItems => contextMenuItems)
  )
  /**
   * Navigation changes tracked for router
   */
  path$ = this.router.events.pipe(
    filter((e: Event): e is Event=> e instanceof NavigationEnd),
    takeUntil(this.destroy$),
    map(e => e)
  );


  @ViewChild("sidebarWatch") rightSideBar: NbSidebarComponent;
  @ViewChild("sidebarWatch",{read:ElementRef}) rightSideBarEl: ElementRef<HTMLElement>;
  mainContent:any;

  /* readonly sidebarState$ = this.rightSideBar.getSidebarState('right').pipe(
    map(state => {
      return state;
    })
  ); */
  
  constructor(
    private router:Router,
    private viewContainersService:ViewContainersService,
    private configurationService:ConfigurationService,
    private sidebarService:NbSidebarService,
    private store:UbsComponentStoreService,
    private menuService:NbMenuService,
    private route:ActivatedRoute) { 
      /* console.log("path: "+this.router.url);
      let parts = this.router.url.split("/");
      console.log("parts: "+parts);
      this.route.url.subscribe(data => {
        console.log(data);
      })
      if(this.router.url.includes("/cms")){

      } */
      
      this.router.events.pipe(
        filter((e: Event): e is Event=> e instanceof NavigationEnd)
      ).subscribe((e: Event) => {
        
        /* let parts = this.router.url.split("/");
        this.appPath$.next(parts[2]);
        console.log("Setting path in event: "+parts[2]);
        this.setMenuAndTitles(parts[2]); */
      });
    /* this.viewContainersService.menuAndTitleOptions$.subscribe((data:MenuAndTitleOptions) => {
      console.log(data)
    })
    this.viewContainersService.menuAndTitleOptions$.pipe(takeUntil(this.destroy$))
    .subscribe((data:MenuAndTitleOptions) => {
      console.log(data);
      this.menu = data.menuItems;
    }) */
    /* this.settingsSubscription = this.viewContainersService.getSettings()
    .subscribe(data => {
      this.settings = data;
      this.settingsLoaded = true;
    }) */
      /* this.sidebarState$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
        console.log(state,"has changed")
        //this.sidebarService.toggle(false, 'right');
      }) */
      

  }
  ngAfterViewInit(): void {
    if(this.rightSideBarEl != undefined){
      console.log(this.rightSideBarEl.nativeElement);
      this.mainContent = <HTMLElement>this.rightSideBarEl.nativeElement.nextSibling;
    }
    this.rightSideBar.stateChange.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      console.log(state,"has changed")
      if(state == "expanded"){
        this.mainContent.style.flex = "0";
      }else{
        this.mainContent.style.flex = "1";
      }
      //console.log("rightSideBar",this.rightSideBar.state = state);
      //this.sidebarService.toggle(false, 'right');
    });
  }
  

  ngOnInit(): void {
    //this.router.events.subscribe((event) => console.log(event));
    
    /* this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event) => {
      console.log("Navigation Started: "+event)
    }); */
    this.menu = [];
    this.settings = [];
    console.log(this.configurationService.baseUrl);
    //this.configurationService.
    //this.configurationService.configSite(environment).subscribe(data => console.log(data));
    /* this.viewContainersService.menuAndTitleOptions$.pipe(takeUntil(this.destroy$)).subscribe((data:MenuAndTitleOptions[]) => {
      console.log(data);
    }) */
    /* this.viewContainersService.menuItems$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
    })
    this.viewContainersService.getMenuItems().pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
    })
    this.viewContainersService.menuItems$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
    }) */
    this.contextMenu$.subscribe((contextMenuItems:NbMenuItem[]) => {
      console.log(contextMenuItems);
      //this.menuService.addItems(contextMenuItems,"contextMenu")
      this.contextMenuItems = contextMenuItems;
    })
    /**
     * Tracking router on first navigation
     */
    this.menuTitleOps$.pipe(takeUntil(this.destroy$)).subscribe((data:MenuAndTitleOptions[]) => {
      console.log(data)
      let parts = this.router.url.split("/");
      console.log("Setting path in event: "+parts[2]);
      this.setMenuAndTitles(parts[2]);
      this.contextMenuItems = [];
    })
    /**
     * Tracking route changes other than initial,navigation
     */
    this.path$.subscribe(_path => {
      console.log("Getting a path ..."+_path);
      let parts = this.router.url.split("/");
      console.log("Setting path in event: "+parts[2]);
      this.setMenuAndTitles(parts[2]);
      this.contextMenuItems = [];
    })
    /* this.sidebarState$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      console.log(state,"has changed")
    }) */
      

  }

  processComponent(componentRef:any){
    console.log(componentRef);
    if(componentRef.contextMenuItems != null) {
      componentRef.contextMenuItems.pipe(takeUntil(this.destroy$)).subscribe((contextMenuItems:NbMenuItem[]) => {
        console.log(contextMenuItems);
        if(contextMenuItems){
          console.log(this.menu.length)
          if(this.menu.length == 0){
            let parts = this.router.url.split("/");
            console.log("Setting path in event: "+parts[2]);
            this.setMenuAndTitles(parts[2]);
          }
          this.contextMenuItems = contextMenuItems;
        }
      });
    }
    if(componentRef.assistantConfig != null){
      componentRef.assistantConfig.pipe(takeUntil(this.destroy$)).subscribe((assistantConfig:AssistantConfig) => {
        this.assistantConfig = assistantConfig;
        console.log(assistantConfig);
        console.log(this.router.url);
        //first check if the current path is the same as the one on the assistantConfig
        let pathCheck = this.router.url.endsWith(this.assistantConfig.path);
        let actionCheck = componentRef.action;
        let triggers = this.assistantConfig.contextualTriggers;
        if(triggers.onCreate && actionCheck == "add" && pathCheck){
          this.assistantConfig.enabled = true;
          this.validAssistant = true;    
        }else{
          this.assistantConfig.enabled = false;
          this.validAssistant = false;
        }
        console.log(this.validAssistant);
        
      });
    }
  }

  setMenuAndTitles(path:string){
    console.log(path)
    this.menuTitleOps$.pipe(takeUntil(this.destroy$)).subscribe((menuAndTitleOptions:MenuAndTitleOptions[]) => {
      let activatedMenu = menuAndTitleOptions.find(menuAndTitleOption => menuAndTitleOption.path == path);
      //console.log(activatedMenu);
      if(activatedMenu != undefined){
        if(this.menuTag != undefined && this.menuTag == activatedMenu.menuTag){
          console.log(activatedMenu);
          /* this.menu = activatedMenu.menuItems;
          this.headerTitle = activatedMenu.headerTitle;
          this.menuTag = activatedMenu.menuTag; */
        }else{
          console.log(activatedMenu);
          this.menu = activatedMenu.menuItems;
          this.headerTitle = activatedMenu.headerTitle;
          this.menuTag = activatedMenu.menuTag;
        }
      
      //this.menuService.addItems([],this.menuTag);
    }
      //console.log(data)
      /* data.forEach(menuStuff => {
        console.log(menuStuff)
      }) */
      
      /* this.headerTitle = data.headerTitle;
      this.menuTag = data.menuTag;
      this.menu = data.menuItems; */ 
      //this.menuService.addItems(data.menuItems,data.menuTag);
    })
  }

  rightSideBarToggle(e){
    console.log(e);
    this.sidebarService.toggle(false, 'right');
  }

  /* getMenuTitle(path:string){
    console.log(path)
    let activatedMenu = this.menuAndTitleOptions.find(menuAndTitleOption => menuAndTitleOption.path === path);
    if(activatedMenu != undefined){
      this.menu = activatedMenu.menuItems;
      this.headerTitle = activatedMenu.headerTitle;
    }
  } */


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

/* 
template:`
  <ngx-one-column-admin-layout>
    <nb-menu tag="menu" [items]="menu"></nb-menu>
    <ng-container *ngIf="settingsLoaded">
      <ubs-admin-settings>
          <ubs-settings-container [settings]="settings"></ubs-settings-container>
      </ubs-admin-settings>
    </ng-container>
    <router-outlet></router-outlet>
  </ngx-one-column-admin-layout>
`
 */

// <ng-content select="nb-menu"></ng-content>
//<ng-content select="router-outlet"></ng-content>